module.exports = __webpack_public_path__ + "img/simone.f82b181a.jpeg";